/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { GreenroomState } from '../../stores/types/types';
import { contrastingColor } from '../../utils/utils';
import type { DropCallback } from '../../stores/types/user-interface';
import { DRAG_TYPE } from '../../stores/reducers/user-interface';
import useDropArea from '../../hooks/use-dnd/use-drop-area';
import colors from '../../utils/colors';

interface Props {
	feedPosition: number;
	email: string;
	dropCallback: DropCallback;

}

export default function FeedEmail(props: Props) {
	const meeting = useSelector((state: GreenroomState) => state.SessionReducer.meeting);

	const { email, dropCallback, feedPosition } = props;

	const colorStyles = useMemo(() => {
		const colorObj = {
			backgroundColor: '#333',
			color: contrastingColor(colors.gray33),
		};

		if (meeting?.primary_color) {
			colorObj.backgroundColor = `#${meeting.primary_color}`;
			colorObj.color = contrastingColor(meeting.primary_color);
		}

		return colorObj;
	}, [meeting]);

	const { isOver, dropRef } = useDropArea({
		accepts: DRAG_TYPE.FEEDS,
		dropCallback,
		dropAreaData: { feedPosition },
	});

	return (
		<>
			{isOver && <div className="dnd-highlighted" />}
			<div ref={dropRef} className={classNames('poster active feed-drop-area')}>
				<div className="email-feed no-image-placeholder">
					<span style={colorStyles}>
						{email.trim()[0]}</span>
				</div>
			</div>
		</>
	);
}
